import axios from 'axios'

import { INVALID_CAPTCHA_TOKEN_CODE } from '@percent/education-hosted-form/constants/captcha'
import { APIErrorResponse } from '@percent/education-hosted-form/types/api.types'

/*
  The response interceptor rewraps API failures as ErrorBase subclasses with the
  original AxiosError on `cause`, so the error code has to be read through either
  shape.
*/
export const isInvalidCaptchaTokenError = (error: unknown): boolean => {
  const axiosError = axios.isAxiosError(error)
    ? error
    : error instanceof Error && axios.isAxiosError(error.cause)
    ? error.cause
    : undefined

  if (axiosError?.response?.status !== 400) {
    return false
  }

  return (axiosError.response.data as APIErrorResponse | undefined)?.error?.code === INVALID_CAPTCHA_TOKEN_CODE
}
